import { Phone } from "lucide-react";

/**
 * Mobile-only inline phone CTA strip.
 * Renders only at < md (caller wraps in `md:hidden`).
 * Uses tel: link — opens dialer on tap. No JS, no form.
 */
export default function MobilePhoneCTA() {
  return (
    <section className="bg-primary px-4 py-4 text-center" aria-label="Call Rex & Sons RVs">
      <a
        href="tel:910-793-2894"
        className="inline-flex items-center gap-2 rounded-lg bg-primary-foreground px-5 py-3 font-heading text-sm font-black uppercase tracking-wide text-primary shadow-md transition active:scale-[0.98]"
      >
        <Phone className="h-4 w-4" aria-hidden />
        Call (910) 793-2894
      </a>
      <p className="mt-2 text-[11px] font-semibold uppercase tracking-wider text-primary-foreground">
        Mon–Sat · Castle Hayne, NC
      </p>
    </section>
  );
}